(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mekkel-impact"] && !Shopify.designMode) return;
  try {
    
function initLegacyCircle(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const summary=root.querySelector('[data-lc-summary]'), amount=root.querySelector('[data-lc-amount]'), interest=root.querySelector('[data-lc-interest]'),tags=root.querySelector('[data-lc-tags]');
 function updateTags(){if(tags&&interest)tags.value='newsletter,goddess-global,legacy-circle-interest,legacy-circle-'+interest.value;}
 function update(){
 const selected=root.querySelector('input[name="lc-tier"]:checked'),frequency=root.querySelector('input[name="lc-frequency"]:checked').value;
 let value=selected.value==='custom'?Number(amount.value):Number(selected.dataset.amount);
 const valid=Number.isFinite(value)&&value>=1&&value<=999999.99&&Math.abs(value*100-Math.round(value*100))<0.00001;
 amount.setCustomValidity(selected.value==='custom'&&!valid?amount.getAttribute('aria-label')||root.querySelector('[id^="LegacyAmountHint-"]').textContent:'');
 summary.textContent=valid?(frequency==='monthly'?summary.dataset.monthly:summary.dataset.once).replace('__AMOUNT__',new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(value)):root.querySelector('[id^="LegacyAmountHint-"]').textContent;
 if(interest)interest.value=selected.value;updateTags();
 }
 root.querySelectorAll('input[name="lc-tier"],input[name="lc-frequency"]').forEach(input=>input.addEventListener('change',update));
 amount.addEventListener('input',()=>{root.querySelector('input[name="lc-tier"][value="custom"]').checked=true;update();});
 if(interest)interest.addEventListener('change',updateTags);
 update();
}
document.querySelectorAll('[data-legacy-circle]').forEach(initLegacyCircle);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-legacy-circle]').forEach(initLegacyCircle));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mekkel-listen-watch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mekkel-music-player')) {
  customElements.define('mekkel-music-player', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-video-track]');
      const previous = this.querySelector('[data-video-prev]');
      const next = this.querySelector('[data-video-next]');
      const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const update = () => {
        if (!track) return;
        const maximum = track.scrollWidth - track.clientWidth;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };
      if (track && previous && next) {
        previous.hidden = false;
        next.hidden = false;
        const move = (direction) => {
          const card = track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: motion() });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(update);
          this.observer.observe(track);
        }
        update();
      }
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-play-video]');
        if (!link || !this.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const id = link.dataset.videoId;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        event.preventDefault();
        const stage = this.querySelector('[data-video-stage]');
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        iframe.title = link.dataset.videoTitle;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        stage.replaceChildren(iframe);
        this.querySelector('[data-current-title]').textContent = link.dataset.videoTitle;
        this.querySelector('[data-watch-link]').href = link.href;
        this.querySelectorAll('.mr-video-card').forEach((card) => {
          if (card.dataset.videoId === id) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
        stage.scrollIntoView({ behavior: motion(), block: 'nearest' });
      });
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
